<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :destroy-on-close="true"
  >
    <div>
      <div class="flex justify-between items-center">
        <p class="text-xl text-black font-bold">Deposit</p>
        <div class="text-right">
          <p class="text-xl font-bold text-black">
            +
            {{
              parseMoneyAll(
                transactionDetails.depositedAmount.amount ||
                  transactionDetails.depositedAmount,
                transactionDetails.depositedAmount.currency ||
                  transactionDetails.depositedCurrency
              )
            }}
          </p>
          <p class="tet-fg-muted font-normal text-sm">
            Same value in
            {{
              transactionDetails.depositedAmount.currency ||
              transactionDetails.depositedCurrency
            }}
          </p>
        </div>
      </div>
      <div class="mt-4">
        <div class="grid grid-cols-12 mb-3">
          <p class="col-span-6 text-fg-muted text-sm font-normal">
            Transaction ID:
          </p>
          <div
            class="col-span-5 flex items-center text-fg-muted text-sm font-medium"
          >
            <p>{{ maskId(transactionDetails.id) }}</p>
            <div
              class="cursor-pointer"
              v-clipboard:copy="transactionDetails.id || '--'"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
              <copy-icon />
            </div>
          </div>
        </div>
        <div class="grid grid-cols-12 mb-3">
          <p class="col-span-6 text-fg-muted text-sm font-normal">
            Payment Method:
          </p>
          <p
            class="col-span-5 flex items-center text-fg-muted text-sm font-medium"
          >
            {{ GBPDeposit ? 'Bank' : 'Wire' }} Transfer
          </p>
        </div>
        <div class="grid grid-cols-12 mb-3">
          <p class="col-span-6 text-fg-muted text-sm font-normal">Status:</p>
          <p
            class="col-span-5 flex items-center justify-center capitalize py-1.5 rounded-md font-medium w-2/3"
            :class="statusClass(transactionDetails.status)"
          >
            {{ transactionDetails.status }}
          </p>
        </div>
        <div class="grid grid-cols-12 mb-3">
          <p class="col-span-6 text-fg-muted text-sm font-normal">
            Deposit Reference:
          </p>
          <p
            class="col-span-5 flex items-center text-fg-muted text-sm font-medium"
          >
            {{ transactionDetails.reference || '--' }}
          </p>
        </div>
        <div class="grid grid-cols-12 mb-3" style="word-break: normal">
          <p class="col-span-6 text-fg-muted text-sm font-normal">
            Deposit details:
          </p>
          <p
            class="col-span-5 flex items-center text-primary cursor-pointer text-xs font-medium"
            @click="goToDepositDetails"
          >
            See Deposit Details
          </p>
        </div>
        <div class="grid grid-cols-12 mb-3" style="word-break: normal">
          <p class="col-span-6 text-fg-muted text-sm font-normal">
            Date & Time
          </p>
          <p
            class="col-span-5 flex items-center text-fg-muted text-sm font-medium"
          >
            {{ $dayjs(transactionDetails.createdAt).format('DD MMM YYYY') }},
            {{ parseLocalTime(transactionDetails.createdAt) }}
          </p>
        </div>
      </div>
      <div class="mt-4 bg rounded-lg p-2.5">
        <p class="text-fg-muted text-13px font-semibold">Note</p>
        <p
          class="text-fg-muted text-13px mt-1.5 font-normal"
          style="word-break: normal"
        >
          Wire transfer transactions may take between 2-4 business days before
          clearing.
        </p>
      </div>
      <el-button
        class="bg-white border border-primary w-full py-3.5 text-primary mt-5 rounded-md text-sm font-normal"
        @click="editTransaction"
        >Edit Transaction</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
import { ParseMoneyAll, MaskID, ParseLocalTime } from '@/utils/helpers.js'
import pendingDeposit from '@/mixins/pendingDeposit.js'
import statusClass from '@/mixins/global.js'
export default {
  mixins: [pendingDeposit, statusClass],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      breakpoints
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDialog')
    },
    parseLocalTime (val) {
      return ParseLocalTime(val)
    },
    parseMoneyAll (amount, currency) {
      return ParseMoneyAll(amount, currency)
    },
    maskId (id) {
      return MaskID(id)
    },
    goToDepositDetails () {
      if (this.USDDeposit) {
        this.$store.dispatch(
          'transactions/setDepositDetailsType',
          'wireTransferInternational'
        )
      } else {
        this.$store.dispatch(
          'transactions/setDepositDetailsType',
          'GBPDepositDetails'
        )
      }
      this.$emit('closeDialog')
      this.$emit('showDepositDetails')
    },
    onCopy: function (e) {
      this.$notify.success({
        title: 'Copied'
      })
    },
    onError: function (e) {
      this.$notify.error('Error copying to clipboard!')
    },
    editTransaction () {
      this.$store.dispatch(
        'report/setAccountDetailsCurrency',
        this.transactionDetails.depositedAmount.currency ||
          this.transactionDetails.depositedCurrency
      )
      this.$store.dispatch('transactions/setPendingDepositState', true)
      this.$emit('closeDialog')
      this.$emit('showDepositDialog')
    }
  },
  components: {
    CopyIcon: () => import('@/assets/icons/CopyIcon.vue')
  },
  computed: {
    transactionDetails () {
      return this.$store.state.transactions.transactionDetails || {}
    },
    modalWidth () {
      return breakpoints.lgAndUp ? '30%' : breakpoints.mdAndUp ? '70%' : '90%'
    },
    USDDeposit () {
      const { depositedAmount, depositedCurrency } = this.transactionDetails
      return (
        depositedAmount.currency === this.$CURRENCY.USD ||
        depositedCurrency === this.$CURRENCY.USD
      )
    },
    GBPDeposit () {
      const { depositedAmount, depositedCurrency } = this.transactionDetails
      return (
        depositedAmount.currency === this.$CURRENCY.GBP ||
        depositedCurrency === this.$CURRENCY.GBP
      )
    }
  }
}
</script>

<style scoped>
>>> .el-dialog {
  border-radius: 16px;
  padding: 5px;
  background-color: white;
}
>>> .el-dialog__close .el-icon .el-icon-close {
  color: black !important;
}
.bg {
  background: var(--input-foreground-disabled);
}
</style>
